export const CdnDataActionTypes = {
    API_RESPONSE_SUCCESS: '@@cdnData/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@cdnData/API_RESPONSE_ERROR',

    FETCH_CDN_DATA: '@@cdnData/FETCH_CDN_DATA',
};
